import React from 'react';

import makeDeprecatedJadeStyleTemplate from 'util/makeDeprecatedJadeStyleTemplate';

function SummaryMap(): JSX.Element {
  return (
    <>
      <div className="controls" />
      <div className="top-map" />
      <div className="map-wrap">
        <div className="map" />
      </div>
      <div className="bottom-map" />
    </>
  );
}

export default makeDeprecatedJadeStyleTemplate(SummaryMap);
